import React, { useEffect, useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useGetProductQuery } from '../../Store/api/apiSlice';
import { getRelatedProducts } from '../../Store/products/productsSlice'
import { useDispatch, useSelector } from 'react-redux';
import Product from './Product';
import Products from './Products';
import { assetUrl } from '../../utils/imageUrl';
import { applyPageSeo, resetPageSeo } from '../../utils/seo';
import { addViewedProduct } from '../../utils/viewedProducts';
import Preloader from '../Preloader/Preloader';

const SingleProduct = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const { list, related } = useSelector(({ products }) => products);

  const { data, isLoading, isFetching, isSuccess } = useGetProductQuery({ id });

  useEffect(() => {
    if(!isLoading && !isFetching && !isSuccess) {
      navigate('/');
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [isLoading, isFetching, isSuccess])

  useEffect(() => {
    if (!data?.category?.id || !list.length) return;
    dispatch(getRelatedProducts(data.category.id));
  }, [data, dispatch, list.length]);

  useEffect(() => {
    if (data?.id) {
      addViewedProduct(data.id);
    }
  }, [data?.id]);

  const manualRelated = useMemo(
    () => (data?.relatedProducts || []).filter((item) => Number(item.id) !== Number(data?.id)),
    [data?.relatedProducts, data?.id]
  );

  const autoRelated = useMemo(
    () => related.filter((item) => Number(item.id) !== Number(data?.id)),
    [related, data?.id]
  );

  const relatedProducts = manualRelated.length > 0 ? manualRelated : autoRelated;

  useEffect(() => {
    if (!data) return;

    applyPageSeo({
      title: data.metaTitle || data.title,
      description: data.metaDescription || data.shortDescription || data.title,
      keywords: data.metaKeywords,
      canonical: `/products/${data.id}`,
      ogImage: data.images?.[0] ? assetUrl(data.images[0]) : undefined,
      ogType: 'product',
    });

    return resetPageSeo;
  }, [data]);

  return !data ? (
    <Preloader message="Завантаження товару…" />
  ) : (
    <>
      <Product {...data} />
      {relatedProducts.length > 0 && (
        <Products
          products={relatedProducts}
          amount={manualRelated.length > 0 ? relatedProducts.length : 4}
          title="Супутні товари"
        />
      )}
    </>
  );
};

export default SingleProduct;
